import { Components } from '@mui/material';

export const MuiToggleButtonGroup: Components['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'watchduty-gap' },
          style: {
            gap: 16,
            '& .MuiToggleButton-root': {
              borderRadius: '8px !important',
            },
          },
        },
      ],
    },
  },
};
